module.exports = __webpack_public_path__ + "static/img/SAVOIA-MAPLE.4f44d8e.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/SAVOIA-MAPLE.png
// module id = zqCO
// module chunks = 0